// extracted by mini-css-extract-plugin
export default {"label":"styles__label___LfUjy","required":"styles__required___YfKiR","description":"styles__description___FeXgP","adminIcon":"styles__adminIcon___BtJ2v"};